document.addEventListener('DOMContentLoaded', () => {
  // Get slideshow els
  const slideshows = document.querySelectorAll(
    '.f-fullscreen__image-wrap--slideshow'
  );

  // Set up for each slideshow
  for (let i = 0; i < slideshows.length; i++) {
    const slideshow = slideshows[i];
    const slideDelay = 5000;

    // Get all slides
    const slides = slideshow.querySelectorAll('.f-fullscreen__image');

    // only run if there's more than 1 slide
    if (slides.length > 1) {
      setInterval(function () {
        // find visible slide
        for (let j = 0; j < slides.length; j++) {
          const slide = slides[j];

          if (slide.matches('.visible')) {
            const currentSlide = slide;
            let nextSlide = null;

            // Get the next slide (or loop back to start)
            if (slides[j + 1]) {
              nextSlide = slides[j + 1];
            } else {
              nextSlide = slides[0];
            }

            // If found nextSlide
            if (nextSlide) {
              // Change visibility to next slide
              currentSlide.classList.remove('visible');
              nextSlide.classList.add('visible');
              break; // stop looping, wait for the next interval
            }
          }
        }
      }, slideDelay);
    }
  }
});
